import { AsyncPipe, NgIf } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, ElementRef, Directive, DestroyRef, EventEmitter, Component, ChangeDetectionStrategy, ViewChildren, ViewChild, Input, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tuiIsNativeMouseFocusable, tuiGetClosestFocusable, tuiIsNativeFocusedIn, tuiClamp, EMPTY_QUERY, TuiItem } from '@taiga-ui/cdk';
import * as i1 from '@taiga-ui/core';
import { TuiButton, TuiHint } from '@taiga-ui/core';
import { TUI_ATTACH_FILES_LOADER, TUI_IMAGE_LOADER, TUI_EDITOR_OPTIONS, TuiEditorTool, TUI_ATTACH_FILES_OPTIONS, TUI_EDITOR_TOOLBAR_TEXTS, TUI_EDITOR_DEFAULT_TOOLS } from '@taiga-ui/editor/common';
import { TuiAlignContent, TuiCode, TuiDetails, TuiDetailsRemove, TuiEditorGroupTool, TuiFontSize, TuiFontStyle, TuiHighlightColor, TuiListConfigs, TuiTableCellColor, TuiTableCreate, TuiTableMergeCells, TuiTableRowColumnManager, TuiTextColor } from '@taiga-ui/editor/components/toolbar-tools';
import { TuiTiptapEditorService } from '@taiga-ui/editor/directives';
import { tuiGetCurrentWordBounds } from '@taiga-ui/editor/utils';
import { take } from 'rxjs';
const _c0 = ["dropdown"];
const _c1 = ["*"];
function TuiToolbar_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "button", 4);
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵlistener("focus", function TuiToolbar_ng_container_0_Template_div_focus_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onTopFocus());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 5);
    i0.ɵɵlistener("focus", function TuiToolbar_ng_container_0_Template_div_focus_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBottomFocus());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tabIndex", ctx_r1.focusable ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabIndex", ctx_r1.focusable ? 0 : -1);
  }
}
function TuiToolbar_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TuiToolbar_fieldset_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "button", 9);
    i0.ɵɵlistener("click", function TuiToolbar_fieldset_3_div_1_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.undo());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 10);
    i0.ɵɵlistener("click", function TuiToolbar_fieldset_3_div_1_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.redo());
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const texts_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.undoDisabled)("iconStart", ctx_r1.icons.undo)("tuiHint", texts_r4.undo);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", texts_r4.undo, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.redoDisabled)("iconStart", ctx_r1.icons.redo)("tuiHint", texts_r4.redo);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", texts_r4.redo, " ");
  }
}
function TuiToolbar_fieldset_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "tui-font-size", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("editor", ctx_r1.editor);
  }
}
function TuiToolbar_fieldset_3_div_3_tui_font_style_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-font-style", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("editor", ctx_r1.editor)("enabledTools", ctx_r1.toolsSet);
  }
}
function TuiToolbar_fieldset_3_div_3_tui_align_content_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-align-content", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("editor", ctx_r1.editor);
  }
}
function TuiToolbar_fieldset_3_div_3_tui_list_configs_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-list-configs", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("editor", ctx_r1.editor);
  }
}
function TuiToolbar_fieldset_3_div_3_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function TuiToolbar_fieldset_3_div_3_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggleQuote());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const texts_r4 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.unorderedList || ctx_r1.orderedList)("iconStart", ctx_r1.icons.quote)("tuiHint", texts_r4.quote);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", texts_r4.quote, " ");
  }
}
function TuiToolbar_fieldset_3_div_3_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function TuiToolbar_fieldset_3_div_3_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onLink());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const texts_r4 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.a || ctx_r1.jumpAnchor)("iconStart", ctx_r1.icons.link)("tuiHint", texts_r4.link);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", texts_r4.link, " ");
  }
}
function TuiToolbar_fieldset_3_div_3_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function TuiToolbar_fieldset_3_div_3_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onLink("#"));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const texts_r4 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.a || ctx_r1.jumpAnchor)("iconStart", ctx_r1.icons.anchor)("tuiHint", texts_r4.insertAnchor);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", texts_r4.insertAnchor, " ");
  }
}
function TuiToolbar_fieldset_3_div_3_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 21);
    i0.ɵɵlistener("click", function TuiToolbar_fieldset_3_div_3_ng_container_7_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const fileUpload_r9 = i0.ɵɵreference(4);
      return i0.ɵɵresetView(fileUpload_r9.click());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 22, 0);
    i0.ɵɵlistener("change", function TuiToolbar_fieldset_3_div_3_ng_container_7_Template_input_change_3_listener() {
      i0.ɵɵrestoreView(_r8);
      const fileUpload_r9 = i0.ɵɵreference(4);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onAttach(fileUpload_r9));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const texts_r4 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("iconStart", ctx_r1.icons.attach)("tuiHint", texts_r4.attach);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", texts_r4.attach, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("accept", ctx_r1.attachOptions.accept)("multiple", ctx_r1.attachOptions.multiple)("tabIndex", -1);
  }
}
function TuiToolbar_fieldset_3_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, TuiToolbar_fieldset_3_div_3_tui_font_style_1_Template, 1, 2, "tui-font-style", 12)(2, TuiToolbar_fieldset_3_div_3_tui_align_content_2_Template, 1, 1, "tui-align-content", 13)(3, TuiToolbar_fieldset_3_div_3_tui_list_configs_3_Template, 1, 1, "tui-list-configs", 13)(4, TuiToolbar_fieldset_3_div_3_button_4_Template, 2, 4, "button", 14)(5, TuiToolbar_fieldset_3_div_3_button_5_Template, 2, 4, "button", 15)(6, TuiToolbar_fieldset_3_div_3_button_6_Template, 2, 4, "button", 16)(7, TuiToolbar_fieldset_3_div_3_ng_container_7_Template, 5, 6, "ng-container", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.formatEnabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Align));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.List));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Quote));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Link));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Anchor));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Attach));
  }
}
function TuiToolbar_fieldset_3_div_4_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function TuiToolbar_fieldset_3_div_4_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggleSubscript());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const texts_r4 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconStart", ctx_r1.icons.sub)("tuiHint", texts_r4.subscript);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", texts_r4.subscript, " ");
  }
}
function TuiToolbar_fieldset_3_div_4_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function TuiToolbar_fieldset_3_div_4_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggleSuperscript());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const texts_r4 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconStart", ctx_r1.icons.sup)("tuiHint", texts_r4.superscript);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", texts_r4.superscript, " ");
  }
}
function TuiToolbar_fieldset_3_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, TuiToolbar_fieldset_3_div_4_button_1_Template, 2, 3, "button", 23)(2, TuiToolbar_fieldset_3_div_4_button_2_Template, 2, 3, "button", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Sub));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Sup));
  }
}
function TuiToolbar_fieldset_3_div_5_tui_text_color_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-text-color", 25);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("colors", ctx_r1.colors)("editor", ctx_r1.editor);
  }
}
function TuiToolbar_fieldset_3_div_5_tui_highlight_color_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-highlight-color", 25);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("colors", ctx_r1.colors)("editor", ctx_r1.editor);
  }
}
function TuiToolbar_fieldset_3_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, TuiToolbar_fieldset_3_div_5_tui_text_color_1_Template, 1, 2, "tui-text-color", 24)(2, TuiToolbar_fieldset_3_div_5_tui_highlight_color_2_Template, 1, 2, "tui-highlight-color", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Color));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Hilite));
  }
}
function TuiToolbar_fieldset_3_div_6_tui_code_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-code", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("editor", ctx_r1.editor);
  }
}
function TuiToolbar_fieldset_3_div_6_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function TuiToolbar_fieldset_3_div_6_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onTeX());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const texts_r4 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconStart", ctx_r1.icons.tex)("tuiHint", texts_r4.tex);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", texts_r4.tex, " ");
  }
}
function TuiToolbar_fieldset_3_div_6_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29)(1, "button", 30);
    i0.ɵɵlistener("click", function TuiToolbar_fieldset_3_div_6_div_3_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r13);
      const image_r14 = i0.ɵɵreference(4);
      return i0.ɵɵresetView(image_r14.click());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 31, 1);
    i0.ɵɵlistener("change", function TuiToolbar_fieldset_3_div_6_div_3_Template_input_change_3_listener() {
      i0.ɵɵrestoreView(_r13);
      const image_r14 = i0.ɵɵreference(4);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onImage(image_r14));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const texts_r4 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("iconStart", ctx_r1.icons.image)("tuiHint", texts_r4.image);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", texts_r4.image, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabIndex", -1);
  }
}
function TuiToolbar_fieldset_3_div_6_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function TuiToolbar_fieldset_3_div_6_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.insertHorizontalRule());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const texts_r4 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconStart", ctx_r1.icons.hr)("tuiHint", texts_r4.insertHorizontalRule);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", texts_r4.insertHorizontalRule, " ");
  }
}
function TuiToolbar_fieldset_3_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, TuiToolbar_fieldset_3_div_6_tui_code_1_Template, 1, 1, "tui-code", 13)(2, TuiToolbar_fieldset_3_div_6_button_2_Template, 2, 3, "button", 26)(3, TuiToolbar_fieldset_3_div_6_div_3_Template, 5, 4, "div", 27)(4, TuiToolbar_fieldset_3_div_6_button_4_Template, 2, 3, "button", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Code));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Tex));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Img));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.HR));
  }
}
function TuiToolbar_fieldset_3_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "button", 21);
    i0.ɵɵlistener("click", function TuiToolbar_fieldset_3_div_7_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r16);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.removeFormat());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const texts_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("iconStart", ctx_r1.icons.clear)("tuiHint", texts_r4.clear);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", texts_r4.clear, " ");
  }
}
function TuiToolbar_fieldset_3_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "tui-details", 32)(2, "tui-details-remove", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("editor", ctx_r1.editor);
    i0.ɵɵadvance();
    i0.ɵɵproperty("editor", ctx_r1.editor);
  }
}
function TuiToolbar_fieldset_3_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "tui-editor-group-tool", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("editor", ctx_r1.editor);
  }
}
function TuiToolbar_fieldset_3_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "tui-table-create", 32)(2, "tui-table-row-column-manager", 32)(3, "tui-table-merge-cells", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("editor", ctx_r1.editor);
    i0.ɵɵadvance();
    i0.ɵɵproperty("editor", ctx_r1.editor);
    i0.ɵɵadvance();
    i0.ɵɵproperty("editor", ctx_r1.editor);
  }
}
function TuiToolbar_fieldset_3_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "tui-table-cell-color", 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("colors", ctx_r1.colors)("editor", ctx_r1.editor);
  }
}
function TuiToolbar_fieldset_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "fieldset", 6);
    i0.ɵɵtemplate(1, TuiToolbar_fieldset_3_div_1_Template, 5, 8, "div", 7)(2, TuiToolbar_fieldset_3_div_2_Template, 2, 1, "div", 7)(3, TuiToolbar_fieldset_3_div_3_Template, 8, 7, "div", 7)(4, TuiToolbar_fieldset_3_div_4_Template, 3, 2, "div", 7)(5, TuiToolbar_fieldset_3_div_5_Template, 3, 2, "div", 7)(6, TuiToolbar_fieldset_3_div_6_Template, 5, 4, "div", 7)(7, TuiToolbar_fieldset_3_div_7_Template, 3, 3, "div", 7)(8, TuiToolbar_fieldset_3_div_8_Template, 3, 2, "div", 7)(9, TuiToolbar_fieldset_3_div_9_Template, 2, 1, "div", 7)(10, TuiToolbar_fieldset_3_div_10_Template, 4, 3, "div", 7)(11, TuiToolbar_fieldset_3_div_11_Template, 2, 2, "div", 7);
    i0.ɵɵelementStart(12, "div", 8);
    i0.ɵɵprojection(13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Undo));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Size));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.firstBigBlockEnabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Sub) || ctx_r1.enabled(ctx_r1.editorTool.Sup));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Color) || ctx_r1.enabled(ctx_r1.editorTool.Hilite));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.secondBigBlockEnabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Clear));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Details));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Group));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.Table));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enabled(ctx_r1.editorTool.CellColor));
  }
}
let TuiToolbarNavigationManager = /*#__PURE__*/(() => {
  class TuiToolbarNavigationManager {
    constructor() {
      this.el = inject(ElementRef).nativeElement;
    }
    findFirstFocusableTool(reversed = false) {
      const tools = reversed ? this.toolsContainers.slice().reverse() : this.toolsContainers;
      for (const el of tools) {
        const focusableElement = tuiIsNativeMouseFocusable(el) ? el : tuiGetClosestFocusable({
          initial: el,
          root: el,
          keyboard: false
        });
        if (focusableElement) {
          return focusableElement;
        }
      }
      return null;
    }
    onHorizontalNavigation(toPrevious) {
      const {
        toolsContainers
      } = this;
      const focusedToolIndex = toolsContainers.findIndex(tuiIsNativeFocusedIn);
      const targetToolIndex = tuiClamp(focusedToolIndex + (toPrevious ? -1 : 1), 0, toolsContainers.length - 1);
      const targetToolWrapper = toolsContainers[targetToolIndex];
      const targetTool = toPrevious ? this.findPreviousTool(targetToolWrapper) : this.findNextTool(targetToolWrapper);
      if (targetTool) {
        targetTool.focus();
      }
    }
    get toolsContainers() {
      return Array.from(this.el.querySelectorAll('[tuiItem]'));
    }
    findPreviousTool(wrapper) {
      if (!wrapper || tuiIsNativeMouseFocusable(wrapper)) {
        return wrapper ?? null;
      }
      const lookedInside = tuiGetClosestFocusable({
        initial: wrapper,
        root: wrapper,
        keyboard: false
      });
      return lookedInside || tuiGetClosestFocusable({
        initial: wrapper,
        root: this.el,
        previous: true,
        keyboard: false
      });
    }
    findNextTool(wrapper) {
      return !wrapper || tuiIsNativeMouseFocusable(wrapper) ? wrapper ?? null : tuiGetClosestFocusable({
        initial: wrapper,
        root: this.el,
        keyboard: false
      });
    }
    static {
      this.ɵfac = function TuiToolbarNavigationManager_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiToolbarNavigationManager)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiToolbarNavigationManager,
        selectors: [["", "tuiToolbarNavigationManager", ""]],
        hostBindings: function TuiToolbarNavigationManager_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.arrowRight.prevent", function TuiToolbarNavigationManager_keydown_arrowRight_prevent_HostBindingHandler() {
              return ctx.onHorizontalNavigation(false);
            })("keydown.arrowLeft.prevent", function TuiToolbarNavigationManager_keydown_arrowLeft_prevent_HostBindingHandler() {
              return ctx.onHorizontalNavigation(true);
            });
          }
        }
      });
    }
  }
  return TuiToolbarNavigationManager;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/// <reference types="@taiga-ui/tsconfig/ng-dev-mode" />
/// <reference types="@taiga-ui/tsconfig/ng-dev-mode" />
let TuiToolbar = /*#__PURE__*/(() => {
  class TuiToolbar {
    constructor() {
      this.dropdowns = EMPTY_QUERY;
      this.filesLoader = inject(TUI_ATTACH_FILES_LOADER, {
        optional: true
      });
      this.destroyRef = inject(DestroyRef);
      this.imageLoader = inject(TUI_IMAGE_LOADER);
      this.options = inject(TUI_EDITOR_OPTIONS);
      this.editorTool = TuiEditorTool;
      this.injectionEditor = inject(TuiTiptapEditorService, {
        optional: true
      });
      this.attachOptions = inject(TUI_ATTACH_FILES_OPTIONS);
      this.texts$ = inject(TUI_EDITOR_TOOLBAR_TEXTS);
      this.toolsSet = new Set(TUI_EDITOR_DEFAULT_TOOLS);
      this.inputEditor = null;
      this.colors = this.options.colors;
      this.disabled = false;
      this.linkAdded = new EventEmitter();
      this.texClicked = new EventEmitter();
      this.fileAttached = new EventEmitter();
      this.el = inject(ElementRef, {
        optional: true
      })?.nativeElement ?? null;
    }
    set tools(value) {
      this.toolsSet = new Set(value);
    }
    get editor() {
      return this.injectionEditor ?? this.inputEditor;
    }
    get icons() {
      return this.options.icons;
    }
    get focused() {
      return tuiIsNativeFocusedIn(this.el) || !!this.dropdowns.find(({
        nativeElement
      }) => tuiIsNativeFocusedIn(nativeElement));
    }
    get focusable() {
      return !this.focused && !this.disabled;
    }
    get unorderedList() {
      return this.editor?.isActive('bulletList') ?? false;
    }
    get orderedList() {
      return this.editor?.isActive('orderedList') ?? false;
    }
    get blockquote() {
      return this.editor?.isActive('blockquote') ?? false;
    }
    get a() {
      return this.editor?.isActive('link') ?? false;
    }
    get jumpAnchor() {
      return this.editor?.isActive('jumpAnchor') ?? false;
    }
    get undoDisabled() {
      return this.editor?.undoDisabled() ?? false;
    }
    get redoDisabled() {
      return this.editor?.redoDisabled() ?? false;
    }
    get subscript() {
      return this.editor?.isActive('subscript') ?? false;
    }
    get superscript() {
      return this.editor?.isActive('superscript') ?? false;
    }
    get formatEnabled() {
      return this.enabled(TuiEditorTool.Bold) || this.enabled(TuiEditorTool.Italic) || this.enabled(TuiEditorTool.Underline) || this.enabled(TuiEditorTool.Strikethrough);
    }
    get firstBigBlockEnabled() {
      return this.formatEnabled || this.enabled(TuiEditorTool.Align) || this.enabled(TuiEditorTool.List) || this.enabled(TuiEditorTool.Quote) || this.enabled(TuiEditorTool.Link) || this.enabled(TuiEditorTool.Anchor) || this.enabled(TuiEditorTool.Attach);
    }
    get secondBigBlockEnabled() {
      return this.enabled(TuiEditorTool.Code) || this.enabled(TuiEditorTool.Tex) || this.enabled(TuiEditorTool.Img) || this.enabled(TuiEditorTool.HR);
    }
    onMouseDown(event, target) {
      if (target.closest('button')) {
        return;
      }
      event.preventDefault();
      this.editor?.focus();
    }
    onBottomFocus() {
      this.focusLast();
    }
    onTopFocus() {
      this.focusFirst();
    }
    onImage(input) {
      const file = input.files?.[0];
      input.value = '';
      if (!file) {
        return;
      }
      this.imageLoader(file).pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe(image => this.addImage(image));
    }
    onAttach(input) {
      const files = Array.from(input.files || []);
      input.value = '';
      if (!files) {
        return;
      }
      if (ngDevMode) {
        console.assert(!!this.filesLoader, 'Please provide TUI_ATTACH_FILES_LOADER, more: https://taiga-family.github.io/editor/starter-kit/Options');
      }
      this.filesLoader?.(files).pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe(attachedFiles => this.fileAttached.emit(attachedFiles));
    }
    onTeX() {
      this.texClicked.emit();
    }
    onLink(url) {
      this.editor?.takeSelectionSnapshot();
      if (url === '#') {
        const range = this.editor?.getSelectionSnapshot();
        const editor = this.editor?.getOriginTiptapEditor();
        const {
          from = range?.anchor
        } = editor ? tuiGetCurrentWordBounds(editor) : {};
        this.editor?.setAnchor('');
        this.editor?.getOriginTiptapEditor()?.commands.focus((from ?? 0) + 1);
      } else {
        this.editor?.toggleLink(url ?? '');
      }
    }
    enabled(tool) {
      return this.toolsSet.has(tool);
    }
    undo() {
      this.editor?.undo();
    }
    redo() {
      this.editor?.redo();
    }
    insertHorizontalRule() {
      this.editor?.setHorizontalRule();
    }
    removeFormat() {
      this.editor?.removeFormat();
    }
    toggleOrderedList() {
      this.editor?.toggleOrderedList();
    }
    toggleQuote() {
      this.editor?.toggleBlockquote();
    }
    toggleSubscript() {
      this.editor?.toggleSubscript();
    }
    toggleSuperscript() {
      this.editor?.toggleSuperscript();
    }
    addImage(image) {
      this.editor?.setImage(image);
    }
    focusFirst() {
      const firstButton = this.navigationManager?.findFirstFocusableTool();
      if (firstButton) {
        firstButton.focus();
      }
    }
    focusLast() {
      const lastButton = this.navigationManager?.findFirstFocusableTool(true);
      if (lastButton) {
        lastButton.focus();
      }
    }
    static {
      this.ɵfac = function TuiToolbar_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiToolbar)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiToolbar,
        selectors: [["tui-toolbar"]],
        viewQuery: function TuiToolbar_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(TuiToolbarNavigationManager, 5);
            i0.ɵɵviewQuery(_c0, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.navigationManager = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdowns = _t);
          }
        },
        hostAttrs: ["role", "toolbar"],
        hostVars: 2,
        hostBindings: function TuiToolbar_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mousedown", function TuiToolbar_mousedown_HostBindingHandler($event) {
              return ctx.onMouseDown($event, $event.target);
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("_disabled", ctx.disabled);
          }
        },
        inputs: {
          inputEditor: [0, "editor", "inputEditor"],
          colors: "colors",
          disabled: "disabled",
          tools: "tools"
        },
        outputs: {
          linkAdded: "linkAdded",
          texClicked: "texClicked",
          fileAttached: "fileAttached"
        },
        ngContentSelectors: _c1,
        decls: 5,
        vars: 7,
        consts: [["fileUpload", ""], ["image", ""], [4, "ngIf"], ["tuiToolbarNavigationManager", "", "class", "t-tools-wrapper", 3, "disabled", 4, "ngIf"], ["type", "button", 1, "t-prevent-parent-label-behavior"], [3, "focus", "tabIndex"], ["tuiToolbarNavigationManager", "", 1, "t-tools-wrapper", 3, "disabled"], ["class", "t-block", 4, "ngIf"], [1, "t-block"], ["appearance", "icon", "automation-id", "toolbar__undo-button", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "tuiItem", "", "type", "button", 1, "t-tool", "t-tool_margin", 3, "click", "disabled", "iconStart", "tuiHint"], ["appearance", "icon", "automation-id", "toolbar__redo-button", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "tuiItem", "", "type", "button", 1, "t-tool", "t-tool_margin", 3, "click", "disabled", "iconStart", "tuiHint"], ["tuiItem", "", 1, "t-tool", "t-wrapper", 3, "editor"], ["tuiItem", "", "class", "t-tool t-wrapper", 3, "editor", "enabledTools", 4, "ngIf"], ["tuiItem", "", "class", "t-tool t-wrapper", 3, "editor", 4, "ngIf"], ["appearance", "icon", "automation-id", "toolbar__quote-button", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "tuiItem", "", "type", "button", "class", "t-tool t-tool_margin", 3, "disabled", "iconStart", "tuiHint", "click", 4, "ngIf"], ["appearance", "icon", "automation-id", "toolbar__link-button", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "type", "button", "class", "t-tool", 3, "disabled", "iconStart", "tuiHint", "click", 4, "ngIf"], ["appearance", "icon", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "type", "button", 3, "disabled", "iconStart", "tuiHint", "click", 4, "ngIf"], ["tuiItem", "", 1, "t-tool", "t-wrapper", 3, "editor", "enabledTools"], ["appearance", "icon", "automation-id", "toolbar__quote-button", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "tuiItem", "", "type", "button", 1, "t-tool", "t-tool_margin", 3, "click", "disabled", "iconStart", "tuiHint"], ["appearance", "icon", "automation-id", "toolbar__link-button", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "type", "button", 1, "t-tool", 3, "click", "disabled", "iconStart", "tuiHint"], ["appearance", "icon", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "type", "button", 3, "click", "disabled", "iconStart", "tuiHint"], ["appearance", "icon", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "tuiItem", "", "type", "button", 1, "t-tool", "t-tool_margin", 3, "click", "iconStart", "tuiHint"], ["type", "file", 1, "t-file-upload", 3, "change", "accept", "multiple", "tabIndex"], ["appearance", "icon", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "tuiItem", "", "type", "button", "class", "t-tool t-tool_margin", 3, "iconStart", "tuiHint", "click", 4, "ngIf"], ["tuiItem", "", "class", "t-tool t-wrapper", 3, "colors", "editor", 4, "ngIf"], ["tuiItem", "", 1, "t-tool", "t-wrapper", 3, "colors", "editor"], ["appearance", "icon", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "tuiItem", "", "type", "button", "class", "t-tool", 3, "iconStart", "tuiHint", "click", 4, "ngIf"], ["tuiItem", "", "class", "t-wrapper", 4, "ngIf"], ["appearance", "icon", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "tuiItem", "", "type", "button", 1, "t-tool", 3, "click", "iconStart", "tuiHint"], ["tuiItem", "", 1, "t-wrapper"], ["appearance", "icon", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "type", "button", 1, "t-tool", 3, "click", "iconStart", "tuiHint"], ["accept", "image/*", "type", "file", 1, "t-image", 3, "change", "tabIndex"], ["tuiItem", "", 1, "t-tool", "t-tool_margin", 3, "editor"]],
        template: function TuiToolbar_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, TuiToolbar_ng_container_0_Template, 4, 2, "ng-container", 2)(1, TuiToolbar_ng_container_1_Template, 1, 0, "ng-container", 2);
            i0.ɵɵpipe(2, "async");
            i0.ɵɵtemplate(3, TuiToolbar_fieldset_3_Template, 14, 12, "fieldset", 3);
            i0.ɵɵpipe(4, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.disabled);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 3, ctx.editor == null ? null : ctx.editor.stateChange$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 5, ctx.texts$));
          }
        },
        dependencies: [AsyncPipe, NgIf, TuiAlignContent, TuiButton, TuiCode, TuiDetails, TuiDetailsRemove, TuiEditorGroupTool, TuiFontSize, TuiFontStyle, TuiHighlightColor, i1.TuiHintDirective, i1.TuiHintDescribe, TuiItem, TuiListConfigs, TuiTableCellColor, TuiTableCreate, TuiTableMergeCells, TuiTableRowColumnManager, TuiTextColor, TuiToolbarNavigationManager],
        styles: ["[_nghost-%COMP%]{position:relative;display:block;isolation:isolate}._disabled[_nghost-%COMP%]{pointer-events:none}tui-editor[_nghost-%COMP%][_nghost-%COMP%]   .t-tools-wrapper[_ngcontent-%COMP%]:has(.t-block:not(:empty)), tui-editor   [_nghost-%COMP%]   .t-tools-wrapper[_ngcontent-%COMP%]:has(.t-block:not(:empty)){border:none;outline:.0625rem solid var(--tui-border-normal)}[_nghost-%COMP%]     button[disabled]{pointer-events:none}.t-tools-wrapper[_ngcontent-%COMP%]{scrollbar-width:none;-ms-overflow-style:none;display:flex;overflow:auto;flex-wrap:wrap;padding:0;margin:0;border:0}.t-tools-wrapper[_ngcontent-%COMP%]::-webkit-scrollbar, .t-tools-wrapper[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{display:none}.t-tools-wrapper[_ngcontent-%COMP%]:has(.t-block:not(:empty)){padding:.25rem .75rem;outline:.0625rem solid var(--tui-border-normal)}.t-tools-wrapper._disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:var(--tui-disabled-opacity)}.t-block[_ngcontent-%COMP%]{display:flex;padding:.25rem 0}.t-block[_ngcontent-%COMP%]:empty{display:none}.t-block[_ngcontent-%COMP%]:not(:last-child):after{content:\"\";display:block;margin:0 .25rem;inline-size:.0625rem;background:var(--tui-background-neutral-1-pressed)}.t-tool[_ngcontent-%COMP%]{transition-property:background;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out}button.t-tool[_ngcontent-%COMP%]:hover, .t-tool[_ngcontent-%COMP%]     button:hover{background:var(--tui-background-neutral-1-hover)}.t-tool_margin[_ngcontent-%COMP%]{margin:0 .25rem}.t-dropdown[_ngcontent-%COMP%]{padding:.75rem}.t-wrapper[_ngcontent-%COMP%]{position:relative;margin:0 .25rem}.t-plate[_ngcontent-%COMP%]{position:absolute;top:1.9rem;left:.25rem;inline-size:1.5rem;block-size:.25rem;pointer-events:none}.t-plate_paint[_ngcontent-%COMP%]{left:.375rem;inline-size:1.25rem}.t-font[_ngcontent-%COMP%]{padding:.3em 0;outline:none;inline-size:100%;pointer-events:none}.t-image[_ngcontent-%COMP%]{position:absolute;top:0;left:0;inline-size:100%;block-size:100%;font-size:0;opacity:0;cursor:pointer}.t-image[_ngcontent-%COMP%]::-webkit-file-upload-button{display:none}.t-file-upload[_ngcontent-%COMP%]{display:none}.t-color-picker[_ngcontent-%COMP%]     tui-hosted-dropdown, .t-color-picker[_ngcontent-%COMP%]     tui-color-picker, .t-color-picker[_ngcontent-%COMP%]     tui-color-edit{display:none}.t-prevent-parent-label-behavior[_ngcontent-%COMP%]{display:none}"],
        changeDetection: 0
      });
    }
  }
  return TuiToolbar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiToolbar, TuiToolbarNavigationManager };
